import './MessagePopup.scss';
import icons from '../../shared/assets/icons/redesign';

const { Cross } = icons;

export default function MessagePopup({ messagePopup, showMessagePopup }) {
  return (
    <div className="messagePopup">
      <div className="messagePopup-content">
        <div className="messagePopup-actions">
          <Cross
            className="messagePopup-close-btn cursor-pointer"
            onClick={() => showMessagePopup({})}
          />
        </div>
        <p className="messagePopup-msg">{messagePopup.message}</p>

        <button
          className="messagePopup-btn cursor-pointer"
          onClick={() => {
            if (messagePopup.buttonLink)
              location.href = messagePopup.buttonLink;
            else showMessagePopup({});
          }}
        >
          {messagePopup.buttonLabel}
        </button>
      </div>
    </div>
  );
}
